import React from 'react';
import { ViewContainer } from './ProteinView.elements';
import { MachinesInTheLineWidget } from './components/MachinesInTheLineWidget/MachinesInTheLineWidget';
import { LineStatusWidget } from './components/LineStatusWidget/LineStatusWidget';
import { DateRangeProvider } from 'components';

export const ProteinView = (): JSX.Element => (
  <ViewContainer className="protein-line-view view-container">
    <DateRangeProvider frequencyRefresh={120000}>
      <MachinesInTheLineWidget />
      <LineStatusWidget />
    </DateRangeProvider>
  </ViewContainer>
);

export default ProteinView;
